import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'

Alpine.plugin(intersect);
Alpine.plugin(focus);

import './alpine/offcanvas.js';
import './alpine/menu.js';
import './alpine/logo.js';
import './alpine/logoLarge.js';

Alpine.start();